import React, { useMemo, useState } from "react";

import { formatPublishedDate } from "../../utils/common";

export default function PodcastEpisode({
    episode,
    currentEpisode,
    isPlaying,
    onEpisodeSelected,
    onTogglePlayPause
}) {

    const [showDescription, setShowDescription] = useState(false);

    const active = currentEpisode && currentEpisode.guid === episode.guid;

    function handleButtonClick() {
        if (active) {
            onTogglePlayPause();
        } else {
            onEpisodeSelected(episode);
        }

    }
    function toggleDescription() {
        setShowDescription(previous => !previous);
    }

    return (

        <div className="podcast-cardx bg-fff">

            <div className="text-center p-10">
                <div className="font-raleway font-size-20l-18m-16s font-weight-600 txt-000 text-left line-height-125per">
                    {episode.title}
                </div>
                <div className="horizontal-container justify-even pt-10">
                    <div className="font-source-sans font-size-20l-18m-16s txt-000 text-justify line-height-125per pt-10">
                        {formatPublishedDate(episode.published)}
                    </div>
                    <div className="justify-centerx">
                        <button
                            className={
                                active && isPlaying
                                    ? "player-button-colored pause"
                                    : "player-button-colored play"
                            }

                            onClick={handleButtonClick}
                        />
                    </div>
                    <div className="font-source-sans font-size-20l-18m-16s txt-000 text-justify line-height-125per pt-10">
                        {episode.duration}
                    </div>
                </div>
                <div className="text-left pt-10">
                    <div className="episode-description-toggle hover-opacity-50 font-raleway font-size-20l-18m-16s font-weight-600 text-left line-height-125per"
                        onClick={toggleDescription}>

                        <span>
                            {showDescription
                                ? "Hide Description"
                                : "Show Description"
                            }
                        </span>

                        <span className="episode-chevron pl-5">
                            {showDescription
                                ? "▲"
                                : "▼"
                            }
                        </span>
                    </div>

                    {showDescription && (
                        <div className="episode-description font-source-sans font-size-20l-18m-16s txt-000 text-justify line-height-125per">
                            {episode.description}
                        </div>
                    )
                    }
                </div>

            </div>

        </div>

    );

}